import { PropsWithChildren } from 'react';
import { StyledContainer, StyledLabel } from './disabled-input.style';

// TODO: move to Shrike 2021/ directory

export type DisabledInputProps = PropsWithChildren<{
  label?: string;
  testId?: string;
}>;

export const DisabledInput = ({ children, label, testId }: DisabledInputProps) => {
  return (
    <StyledLabel fontFamily="medium">
      {label}
      <StyledContainer testId={testId}>{children}</StyledContainer>
    </StyledLabel>
  );
};
